/* eslint-disable @typescript-eslint/no-explicit-any */
import { formatValue } from "@/lib/pointUtils";
import { activityStore } from "@/stores/activityStore";
import {
  ActivityTypeDescEnum,
  ActivityTypeEnum,
} from "@/types/compontent/base/baseEnum";
import { ActivityCfg } from "@/types/swagger/appserver";

export type PermissionListTypes = Record<string, number>;

export const VIP_ACT_LIST = [
  ActivityTypeEnum.vipUpgrade, // 31
  ActivityTypeEnum.vipRebate, // 27
  ActivityTypeEnum.vipLossRebate, // 42
  ActivityTypeEnum.vipWeekly, // 29
  ActivityTypeEnum.vipMonth, // 40
  ActivityTypeEnum.vipDayBonus, // 23
  ActivityTypeEnum.vipWeeklyRebate, // 24
  ActivityTypeEnum.vipMonthBonus, // 25
  ActivityTypeEnum.weeklyRebate, // 76
];

// VIP特殊活动列表
const VIP_SPECIAL_ACTIVITIES = [
  ActivityTypeEnum.vipHost,
  ActivityTypeEnum.vipExclusive,
  ActivityTypeEnum.vipLuxury,
];

type vipActivityObjectTypes = Partial<
  Record<
    ActivityTypeEnum,
    {
      title: string;
      title_i18n: string;
      text: string;
      text_i18n: string;
      tip?: string;
      vip?: number;
      image: string;
      index: number;
      type?: number;
      key: ActivityTypeEnum;
      center?: string;
      group?: number;
    }
  >
>;

export const vipActivityObject: vipActivityObjectTypes = {
  /* 31 - 升级奖励 */
  [ActivityTypeEnum.vipUpgrade]: {
    title: "Level Bonus",
    title_i18n: "vip.level_bonus",
    text: "VIP upgrades can get high bonus.",
    text_i18n: "vip.level_up_bonus",
    image: "vip_upgrade",
    index: 1,
    type: 1,
    key: ActivityTypeEnum.vipUpgrade,
  },
  /* 27 - 日投注返利 */
  [ActivityTypeEnum.vipRebate]: {
    title: "Daily Cashback",
    title_i18n: "vip.daily_cashback",
    text: "Get cashback based on your bets yesterday.",
    text_i18n: "vip.cashback_yesterday",
    image: "vip_rebate",
    index: 6,
    key: ActivityTypeEnum.vipRebate,
  },
  /* 76 -周体育投注返利 */
  [ActivityTypeEnum.weeklyRebate]: {
    title: "Sports Weekly Cashback",
    title_i18n: "vip.sports_weekly_cashback",
    text: "Get cashback based on your sports bets from the past week.",
    text_i18n: "vip.cashback_sports_week",
    image: "vip_sport_weekly_rebate",
    index: 8,
    key: ActivityTypeEnum.weeklyRebate,
  },
  /* 42 - 亏损返现 */
  [ActivityTypeEnum.vipLossRebate]: {
    title: "Weekly Lossback",
    title_i18n: "vip.weekly_lossback",
    text: "Get lossback based on the amount of your losses last week.",
    text_i18n: "vip.lossback_weekly",
    image: "vip_lossrebate",
    index: 2,
    key: ActivityTypeEnum.vipLossRebate,
  },
  /* 23 - 日奖金 */
  [ActivityTypeEnum.vipDayBonus]: {
    title: "Daily Bonus",
    title_i18n: "vip.dailypoints",
    text: "Claim free bonus every day.",
    text_i18n: "vip.daily_bonus",
    image: "vip_day_bonus",
    index: 3,
    type: 1,
    key: ActivityTypeEnum.vipDayBonus,
  },
  /* 29 - 周奖金 */
  [ActivityTypeEnum.vipWeekly]: {
    title: "Weekly Bonus",
    title_i18n: "vip.weeklypoints",
    text: "Claim free bonus every week.",
    text_i18n: "vip.weekly_bonus",
    image: "vip_weekly",
    index: 4,
    type: 1,
    key: ActivityTypeEnum.vipWeekly,
  },
  /* 24 - 周投注返利  */
  [ActivityTypeEnum.vipWeeklyRebate]: {
    title: "Weekly Cashback",
    title_i18n: "vip.weekly_cashback",
    text: "Get cashback based on your bets from the last week.",
    text_i18n: "vip.lossback_weekly",
    image: "vip_weekly_rebate",
    index: 7,
    key: ActivityTypeEnum.vipWeeklyRebate,
  },
  /* 40 - 月投注返利 */
  [ActivityTypeEnum.vipMonth]: {
    title: "Monthly Cashback",
    title_i18n: "vip.monthly_cashback",
    text: "Get cashback based on your bets from last month.",
    text_i18n: "vip.cashback_last_month",
    image: "vip_month",
    index: 9,
    key: ActivityTypeEnum.vipMonth,
  },
  /* 25- 月奖金 */
  [ActivityTypeEnum.vipMonthBonus]: {
    title: "Monthly Bonus",
    title_i18n: "vip.monthlypoints",
    text: "Claim free bonus each month.",
    text_i18n: "vip.monthly_bonus",
    image: "vip_month_bonus",
    index: 5,
    type: 1,
    key: ActivityTypeEnum.vipMonthBonus,
  },
  /* 6001 - VIP支持 */
  [ActivityTypeEnum.vipHost]: {
    title: "VIP Support",
    title_i18n: "vip.supportservice",
    text: "Experience VIP treatment with exclusive VIP support.",
    text_i18n: "vip.support",
    image: "vip_host",
    index: 11,
    group: 5,
    vip: 10,
    key: ActivityTypeEnum.vipHost,
  },
  /* 6002 - 专属奖励 */
  [ActivityTypeEnum.vipExclusive]: {
    title: "Exclusive Rewards",
    title_i18n: "vip.exclusive_rewards",
    text: "Reach new heights,unlock exclusive bonuses.",
    text_i18n: "vip.levelup_rewards",
    image: "vip_exclusive",
    index: 12,
    group: 7,
    vip: 13,
    key: ActivityTypeEnum.vipExclusive,
  },
  /* 6003 - 豪华礼包 */
  [ActivityTypeEnum.vipLuxury]: {
    title: "Premium Giveaways",
    title_i18n: "vip.premium_giveaways",
    text: "Unlock premium giveaways-claim extravagant rewards!",
    text_i18n: "vip.giveaway_rewards",
    image: "vip_luxury",
    index: 13,
    group: 8,
    vip: 15,
    key: ActivityTypeEnum.vipLuxury,
  },
};

export const useVipActivity = () => {
  // 升级奖励
  const findVipUpgrade = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.vipUpgrade] as ActivityCfg;
    /* prettier-ignore */
    return actCfgData?.cfg?.levels?.find((item: any) => item.vip === vip) || ({} as any) || undefined ;
  };

  // 投注返现
  const findVipRebate = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.vipRebate] as ActivityCfg;
    /* prettier-ignore */
    return actCfgData?.cfg?.vip_cfg?.find((el: { vip_level: number }) => el?.vip_level === vip) || undefined;
  };

  // 投注返现 - flow
  const findVipRebateFlow = (vip: number) => {
    let vipRebateFlow = 0;
    const vipRebate = findVipRebate(vip);

    if (vipRebate?.game_reward_config) {
      vipRebate.game_reward_config.forEach((el: any) => {
        if (el?.reward && el?.reward?.flow_pro > vipRebateFlow) {
          vipRebateFlow = el?.reward?.flow_pro;
        }
      });
    }
    return vipRebateFlow || undefined;
  };

  // 日奖金
  const findVipDayBonus = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.vipDayBonus] as ActivityCfg;
    /* prettier-ignore */
    return actCfgData?.cfg?.vip_cfg?.find((el: any) => el?.vip_level === vip) || undefined;
  };

  // 周体育投注返利
  const findWeeklyRebate = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.weeklyRebate] as ActivityCfg;
    let weeklyRebate;
    if (actCfgData?.cfg) {
      const list = actCfgData?.cfg?.vip_cfg || [];
      weeklyRebate = list.find((el: any) => el?.vip_level == vip);
    }
    return weeklyRebate || undefined;
  };

  //周体育投注返利 - flow
  const findWeeklyRebateFlow = (vip: number) => {
    let weeklyRebateFlow = 0;
    const weeklyRebate = findWeeklyRebate(vip);

    if (weeklyRebate?.game_reward_config) {
      // 检查是否为数组
      if (Array.isArray(weeklyRebate?.game_reward_config)) {
        weeklyRebate?.game_reward_config?.forEach((el: any) => {
          if (el?.reward && el?.reward?.flow_pro > weeklyRebateFlow) {
            weeklyRebateFlow = el?.reward?.flow_pro;
          }
        });
      } else {
        // 如果不是数组，当作对象处理
        if (
          weeklyRebate?.game_reward_config?.reward &&
          weeklyRebate?.game_reward_config?.reward?.flow_pro > weeklyRebateFlow
        ) {
          weeklyRebateFlow = weeklyRebate?.game_reward_config?.reward?.flow_pro;
        }
      }
    }

    return weeklyRebateFlow || undefined;
  };

  // 亏损返现
  const findVipLossRebate = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.vipLossRebate] as ActivityCfg;
    /* prettier-ignore */
    return actCfgData?.cfg?.vip_cfg?.find((el: any) => el?.vip_level == vip) || undefined;
  };

  // 周奖金
  const findVipWeekly = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.vipWeekly] as ActivityCfg;

    if (!actCfgData?.cfg) return undefined;

    const list = actCfgData?.cfg?.vip_cfg || [];
    const vipWeekly = list.find((el: any) => el?.vip_level == vip);

    return vipWeekly || undefined;
  };

  // 周返现
  const findVipWeeklyRebate = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.weeklyRebate] as ActivityCfg;

    if (!actCfgData) return;

    const list = actCfgData?.cfg?.vip_cfg || [];
    const vipWeeklyRebate = list.find((el: any) => el?.vip_level == vip);

    return vipWeeklyRebate || undefined;
  };

  // 周返现 - flow
  const findVipWeeklyRebateFlow = (vip: number) => {
    let vipWeeklyRebateFlow = 0;
    const vipWeeklyRebate = findVipWeeklyRebate(vip);
    if (vipWeeklyRebate?.game_reward_config) {
      // 检查是否为数组
      if (Array.isArray(vipWeeklyRebate.game_reward_config)) {
        vipWeeklyRebate.game_reward_config.forEach((el: any) => {
          if (el?.reward && el?.reward?.flow_pro > vipWeeklyRebateFlow) {
            vipWeeklyRebateFlow = el?.reward?.flow_pro;
          }
        });
      } else {
        // 如果不是数组，当作对象处理
        if (
          vipWeeklyRebate?.game_reward_config?.reward &&
          vipWeeklyRebate?.game_reward_config?.reward?.flow_pro >
            vipWeeklyRebateFlow
        ) {
          vipWeeklyRebateFlow =
            vipWeeklyRebate?.game_reward_config?.reward?.flow_pro;
        }
      }
    }

    return vipWeeklyRebateFlow || undefined;
  };

  // 月返现
  const findVipMonth = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.vipMonth] as ActivityCfg;

    if (!actCfgData?.cfg) return undefined;

    const list = actCfgData?.cfg?.vip_cfg || [];
    const vipMonth = list.find((el: any) => el?.vip_level == vip);

    return vipMonth || undefined;
  };

  // 月返现 - flow
  const findVipMonthFlow = (vip: number) => {
    let vipMonthFlow = 0;
    const vipMonth = findVipMonth(vip);
    if (vipMonth?.game_reward_config) {
      // 检查是否为数组
      if (Array.isArray(vipMonth.game_reward_config)) {
        vipMonth.game_reward_config.forEach((el: any) => {
          if (el?.reward && el?.reward?.flow_pro > vipMonthFlow) {
            vipMonthFlow = el?.reward?.flow_pro;
          }
        });
      } else {
        // 如果不是数组，当作对象处理
        if (
          vipMonth?.game_reward_config?.reward &&
          vipMonth?.game_reward_config?.reward?.flow_pro > vipMonthFlow
        ) {
          vipMonthFlow = vipMonth?.game_reward_config?.reward?.flow_pro;
        }
      }
    }
    return vipMonthFlow || undefined;
  };

  // 月奖金
  const findVipMonthBonus = (vip: number) => {
    /* prettier-ignore */
    const actCfgData = activityStore?.actConfigData?.[ActivityTypeEnum.vipMonthBonus] as ActivityCfg;

    if (!actCfgData?.cfg) return undefined;

    const list = actCfgData?.cfg?.vip_cfg || [];
    const vipMonthBonus = list.find((el: any) => el?.vip_level == vip);

    return vipMonthBonus || undefined;
  };

  const getVipReward = (aType: ActivityTypeEnum, vipLevel: number) => {
    const targetCfg = activityStore?.actConfigData?.[aType];
    if (!targetCfg) return [];

    let reward;
    let value: number | undefined = 0;

    switch (aType) {
      // 升级奖励
      case ActivityTypeEnum.vipUpgrade:
        reward = findVipUpgrade(vipLevel)?.reward;
        break;
      // 投注返现
      case ActivityTypeEnum.vipRebate:
        value = findVipRebateFlow(vipLevel);
        return formatValue(value, 2) || 0;
      // 日奖金
      case ActivityTypeEnum.vipDayBonus:
        reward = findVipDayBonus(vipLevel)?.reward;
        break;

      // 周体育投注返利
      case ActivityTypeEnum.weeklyRebate:
        /* prettier-ignore */
        value = findWeeklyRebateFlow(vipLevel);
        return formatValue(value, 2) || 0;

      // 亏损返现
      case ActivityTypeEnum.vipLossRebate:
        reward = findVipLossRebate(vipLevel)?.reward;
        break;
      // 周奖金
      case ActivityTypeEnum.vipWeekly:
        reward = findVipWeekly(vipLevel)?.reward;
        break;
      case ActivityTypeEnum.vipWeeklyRebate:
        value = findVipWeeklyRebateFlow(vipLevel);
        return formatValue(value, 2) || 0;
      case ActivityTypeEnum.vipMonth:
        value = findVipMonthFlow(vipLevel);
        return formatValue(value, 2) || 0;
      case ActivityTypeEnum.vipMonthBonus:
        reward = findVipMonthBonus(vipLevel)?.reward;
        break;
      default:
        return [];
    }

    if (vipActivityObject[aType]?.type == 1) {
      return reward?.point || 0;
    } else {
      if (reward?.flow_pro) {
        return (reward?.flow_pro / 100).toFixed(2);
      } else {
        return 0;
      }
    }
  };

  const getVipValue = (
    aType: ActivityTypeDescEnum,
    result: { [key: string]: number | string },
  ) => {
    const value = result[aType] as number;
    if (
      [
        ActivityTypeDescEnum.vipDailyRebate,
        ActivityTypeDescEnum.vipMonthlyRebate,
        ActivityTypeDescEnum.lossRebate,
      ].includes(aType)
    ) {
      return formatValue(value, 2) || 0;
    }
    return value;
  };

  /**
   * 计算VIP权限列表 根据活动配置计算每个活动的最低VIP等级要求
   *
   * @returns PermissionList 权限列表
   */
  const getVipPermissionList = (): PermissionListTypes => {
    const list = VIP_ACT_LIST.reduce((acc, cur) => {
      const act = activityStore?.actConfigData?.[cur];
      if (!act?.cfg) return acc;

      if ("vip_cfg" in act.cfg) {
        const vipCfg = act?.cfg?.vip_cfg as Array<{ vip_level: number }>;
        const targetCfg = vipCfg.find(
          (el) => el.vip_level && Object.keys(el).length > 1,
        );

        const minimumVipLevel = targetCfg?.vip_level;
        if (minimumVipLevel) acc[cur] = minimumVipLevel;
      }
      if ("levels" in act.cfg) {
        const levels = act?.cfg?.levels as Array<{ vip: number }>;
        const targetCfg = levels.find(
          (el) => el.vip && Object.keys(el).length > 1,
        );
        const minimumVipLevel = targetCfg?.vip;
        if (minimumVipLevel) acc[cur] = minimumVipLevel;
      }

      return acc;
    }, {} as PermissionListTypes);

    return list;
  };

  /**
   * 过滤VIP权益列表 根据权限列表和特殊活动过滤显示的权益
   *
   * @param permissionList 权限列表
   * @returns 过滤后的权益列表
   */
  const getFilteredVipBenefits = (permissionList: PermissionListTypes) => {
    return (
      Object.values(vipActivityObject || {})
        ?.filter(
          (item) =>
            permissionList[item.key] ||
            VIP_SPECIAL_ACTIVITIES.includes(item.key),
        )
        // 需要按照里面的 index 排序
        .sort((a, b) => a.index - b.index)
    );
  };

  // 按照VIP等级排序的权益列表
  const getSortedVipBenefits = (permissionList: PermissionListTypes) => {
    return (
      [
        ...Object.entries(permissionList),
        ...VIP_SPECIAL_ACTIVITIES.map((i: number) => [i, i]),
      ]
        .sort((a, b) => a[1] - b[1])
        ?.filter((item) => vipActivityObject[item[0] as ActivityTypeEnum])
        .map((item) => vipActivityObject[item[0] as ActivityTypeEnum])
        // 解决类型问题
        .filter((item): item is NonNullable<typeof item> => item !== undefined)
    );
  };

  /**
   * 过滤FAQ列表 根据权限列表和特殊活动过滤显示的FAQ
   *
   * @param permissionList 权限列表
   * @param faqItems FAQ项目列表
   * @returns 过滤后的FAQ列表
   */
  const getFilteredFaqItems = (
    permissionList: PermissionListTypes,
    faqItems: Array<{
      key: ActivityTypeEnum;
      question: string;
      answer: string;
    }>,
  ) => {
    return faqItems?.filter(
      (item) =>
        permissionList[item.key] || VIP_SPECIAL_ACTIVITIES.includes(item.key),
    );
  };
  /**
   * 检查VIP权益是否解锁
   *
   * @param currentVipLevel 当前VIP等级
   * @param requiredLevel 所需VIP等级
   * @returns 是否解锁
   */
  const isVipBenefitUnlocked = (
    currentVipLevel: number,
    requiredLevel: number,
  ): boolean => {
    return currentVipLevel >= requiredLevel;
  };

  return {
    // 升级奖励
    findVipUpgrade,
    // 投注返现
    findVipRebate,
    // 投注返现 - flow
    findVipRebateFlow,
    // 日奖金
    findVipDayBonus,
    // 周体育投注返利
    findWeeklyRebate,
    // 周体育投注返利 - flow
    findWeeklyRebateFlow,
    // 亏损返现
    findVipLossRebate,
    // 周奖金
    findVipWeekly,
    // 周返现
    findVipWeeklyRebate,
    // 周返现 - flow
    findVipWeeklyRebateFlow,
    // 月奖金
    findVipMonth,
    // 月返现
    findVipMonthBonus,
    // 月返现 - flow
    findVipMonthFlow,

    // 入口
    getVipReward,

    getVipValue,

    // 权限列表
    getVipPermissionList,
    getFilteredVipBenefits,
    getFilteredFaqItems,
    isVipBenefitUnlocked,
    // 按照VIP等级排序
    getSortedVipBenefits,
  };
};
